module.exports = __webpack_public_path__ + "img/tmf-castle.3a3c32c6.webp";